var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBrokenEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "47px",
    viewBox: "0 0 22 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-broken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-binders",
    transform: "translate(-398.000000, -325.000000)",
    fill: "#9DB913",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(398.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-broken",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125,32.5 L5.21875,32.5 C4.54565296,32.5 4,31.954347 4,31.28125 C4,30.608153 4.54565296,30.0625 5.21875,30.0625 L11.3125,30.0625 C15.3510822,30.0625 18.625,26.7885822 18.625,22.75 C18.625,18.7114178 15.3510822,15.4375 11.3125,15.4375 L5.21875,15.4375 C4.54565296,15.4375 4,14.891847 4,14.21875 C4,13.545653 4.54565296,13 5.21875,13 L11.3125,13 C16.6972763,13 21.0625,17.3652237 21.0625,22.75 C21.0625,28.1347763 16.6972763,32.5 11.3125,32.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.109375,46.125 C0.496684106,46.125 0,45.7562345 0,45.3013393 L0,0.823660714 C0,0.368765463 0.496684106,0 1.109375,0 C1.72206589,0 2.21875,0.368765463 2.21875,0.823660714 L2.21875,45.3013393 C2.21875,45.7562345 1.72206589,46.125 1.109375,46.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09375,22 L3,22 L3,24.4375 L9.09375,24.4375 C9.76684704,24.4375 10.3125,23.891847 10.3125,23.21875 C10.3125,22.545653 9.76684704,22 9.09375,22 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBrokenEnd);
export default __webpack_public_path__ + "static/media/link-broken-end.c3d458b2be0f35844c2b0a1f15d3b310.svg";
export { ForwardRef as ReactComponent };